export default __webpack_public_path__ + "static/media/preAcct.c464127f.png";